// src/services/propertyService.ts
import { ref, get, set, remove, push, query, orderByChild, equalTo } from 'firebase/database';
import { db } from '../lib/firebase';
import { Property } from '../types/property';

export const loadPropertyForEstimate = (propertyId: string) => {
  // Charger les données du bien
  // Initialiser le formulaire sans consommer de crédit
  // Démarrer à preparationStep
};

export const createProperty = async (userId: string, data: Omit<Property, 'id'>): Promise<string> => {
  const propertiesRef = ref(db, `properties/${userId}`);
  const newPropertyRef = push(propertiesRef);
  
  await set(newPropertyRef, {
    ...data,
    id: newPropertyRef.key
  });
  
  return newPropertyRef.key as string;
};

export const getProperties = async (userId: string): Promise<Property[]> => {
  const propertiesRef = ref(db, `properties/${userId}`);
  const snapshot = await get(propertiesRef);
  
  if (!snapshot.exists()) {
    return [];
  }
  
  return Object.values(snapshot.val());
};

export const getProperty = async (userId: string, propertyId: string): Promise<Property | null> => {
  const propertyRef = ref(db, `properties/${userId}/${propertyId}`);
  const snapshot = await get(propertyRef);
  
  if (!snapshot.exists()) {
    return null;
  }
  
  return snapshot.val();
};

export const updateProperty = async (
  userId: string, 
  propertyId: string, 
  updates: Partial<Property>
): Promise<void> => {
  const propertyRef = ref(db, `properties/${userId}/${propertyId}`);
  const snapshot = await get(propertyRef);
  
  if (!snapshot.exists()) {
    throw new Error('Property not found');
  }
  
  await set(propertyRef, {
    ...snapshot.val(),
    ...updates
  });
};

export const findPropertyByAddress = async (
  userId: string, 
  address: string, 
  postcode: string
): Promise<Property | null> => {
  const propertiesRef = ref(db, `properties/${userId}`);
  const snapshot = await get(propertiesRef);
  
  if (!snapshot.exists()) {
    return null;
  }
  
  const properties = Object.values(snapshot.val()) as Property[];
  return properties.find(p => p.address === address && p.postcode === postcode) || null;
};

export const deleteProperty = async (userId: string, propertyId: string): Promise<void> => {
  const propertyRef = ref(db, `properties/${userId}/${propertyId}`);
  await remove(propertyRef);
};
